import { OrderFacade } from '@spartacus/order/root'
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { MbCheckoutTypes } from '../../models'
import { Cart, OrderEntry } from '@spartacus/cart/base/root'

@Injectable({
  providedIn: 'root'
})
export class CartCheckoutService {

  mbCheckoutType = MbCheckoutTypes

  constructor (protected orderFacade: OrderFacade) {
  }

  isRequestCheckoutType (cart: Cart) {
    return cart.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_A
      || cart.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_B
      || cart.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_C
  }

  getTotalQuantityOfTypeOfItems (type: string, cart: Cart) {
    let counter = 0
    cart?.entries?.forEach(entry => {
      if (entry?.orderEntryType === type) {
        counter += +(entry?.quantity || 0)
      }
    })
    return counter
  }

  getOrderPrice (item: OrderEntry) {
    return this.orderFacade.getOrderDetails().pipe(
      map(order => order?.entries),
      map(entries => entries?.find(entry => entry?.product?.code === item?.product?.code)
      ))
  }

  isCustomerSpecificOrder () {
    return this.orderFacade.getOrderDetails().pipe(
      map(order => !!(order?.erpPricesAreCustomerSpecific && !order?.erpPricingError)
      )
    )
  }
}
